import React, {forwardRef, useImperativeHandle, useState} from "react";
import ValidateMessages from "../../../../core/models/static/texts/vallidate-messages";
import Api from "../../../../core/services/api/api";
import ApiResponseCodes from "../../../../core/models/static/api-response-codes";
import {OutlinedInputForm} from "./outlined_input";
import useAccessLevels from "../../../hooks/use-access-levels";

const RGAInput = ({setValidating, onDuplicateFound, onValidFound, manual, ignore, ...props}, ref) => {
    const {packages} = useAccessLevels();
    const [RGAValidation, setRGAValidation] = useState({validating: false, message: null, error: false, rga: null})

    /**
     * Exposes some intended logic to the parent component:
     * - resetting the validation
     */
    useImperativeHandle(ref, () => ({
        resetValidation: () => setRGAValidation({validating: false, message: null, error: false, rga: null})
    }), [])

    /**
     * Validates the RGA by checking if its a number and then validates it in the server
     * @param rga {string}
     * @return {Promise<boolean>} whether the rga is valid or not.
     */
    const validateRGA = async (rga) => {
        if (rga !== RGAValidation.rga) {
            setRGAValidation(prevState => ({...prevState, rga: rga}));
        } else {
            return !RGAValidation.error;
        }
        if (manual && !rga?.length) {
            setRGAValidation(prevState => ({
                ...prevState,
                error: true,
                message: ValidateMessages.required,
            }));
            return false;
        }
        if (!rga?.length) {
            setRGAValidation(prevState => ({...prevState, error: false, message: null}));
            return true;
        }
        setRGAValidation(prevState => ({...prevState, validating: true}));
        if (ignore?.map(e => e.toLowerCase())?.includes(rga?.toLowerCase() ?? '')) {
            return true;
        }
        if (!packages.warrantyAndReturn.submitRequest && !packages.warrantyAndReturn.editRequest) {
            return true;
        }
        if (setValidating) setValidating(true)
        const validateRes = await Api.validateRGA(rga);
        if (setValidating) setValidating(false)
        if (!validateRes?.resultFlag && validateRes.errorCode === ApiResponseCodes.invalidRGA) {
            if (onDuplicateFound) onDuplicateFound(validateRes.data);
            setRGAValidation(prevState => ({
                ...prevState,
                validating: false,
                error: true,
                message: validateRes.message
            }));
            return false;
        }
        if (onValidFound) onValidFound(rga);
        setRGAValidation(prevState => ({...prevState, validating: false, error: false, message: null}));
        return true;
    }

    /**
     * Validates the RGA input.
     * @param value {string}
     * @return {string | null}
     */
    const validateRGAFormat = (value) => {
        if (manual && !value?.length) {
            return ValidateMessages.required;
        }
        if (!value?.length) {
            return null;
        }
        return null;
    }

    return (
        <>
            <OutlinedInputForm
                error={!!RGAValidation.error}
                helperText={!!RGAValidation.error ? RGAValidation.message : null}
                disabled={!manual}
                label={'RGA'}
                type={'text'}
                {...props}
                onBlur={(e) => validateRGA(e.target.value)}
                fieldProps={{
                    validate: validateRGAFormat
                }}
            />
        </>
    )
}

export default forwardRef(RGAInput);
